module.exports = __webpack_public_path__ + "static/media/menu-prize_chest-icon.cf2bc2f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu-prize_chest-icon.svg
// module id = ./src/assets/images/menu-prize_chest-icon.svg
// module chunks = 0